/**
 * Lazy-loaded wrapper for MortgagePathsDiagramV2
 * Following the exact pattern used for charts on homepage
 * This reduces initial bundle size by ~200-400KB
 */

'use client';

import dynamic from 'next/dynamic';

// Lazy load the visual component
export const LazyMortgagePathsDiagramV2 = dynamic(
  () => import('../../lib/visual-components').then(mod => ({ 
    default: mod.MortgagePathsDiagramV2 
  })),
  { 
    ssr: false,
    loading: () => (
      <div className="h-[400px] bg-gray-50 animate-pulse rounded-lg flex items-center justify-center">
        <span className="text-gray-400">Loading diagram...</span>
      </div>
    )
  }
);

// Export wrapper function for MDX usage
export function LazyServerMortgagePathsDiagramV2(props: any) {
  return <LazyMortgagePathsDiagramV2 {...props} />;
}

// Convenience wrapper matching the original
export function LazyMortgagePathsV2(props: any) {
  return <LazyMortgagePathsDiagramV2 size="inline" showDownload={true} {...props} />;
}